var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlashSuspendedev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.0625C4.5525 17.0625 0.9375 13.4475 0.9375 9C0.9375 4.5525 4.5525 0.9375 9 0.9375C13.4475 0.9375 17.0625 4.5525 17.0625 9C17.0625 13.4475 13.4475 17.0625 9 17.0625ZM9 2.0625C5.175 2.0625 2.0625 5.175 2.0625 9C2.0625 12.825 5.175 15.9375 9 15.9375C12.825 15.9375 15.9375 12.825 15.9375 9C15.9375 5.175 12.825 2.0625 9 2.0625Z",
    fill: "#B3261E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67488 14.8126C3.53238 14.8126 3.38988 14.7601 3.27738 14.6476C3.05988 14.4301 3.05988 14.0701 3.27738 13.8526L13.7774 3.35258C13.9949 3.13508 14.3549 3.13508 14.5724 3.35258C14.7899 3.57008 14.7899 3.93008 14.5724 4.14758L4.07238 14.6476C3.95988 14.7601 3.81738 14.8126 3.67488 14.8126Z",
    fill: "#B3261E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlashSuspendedev);
export default __webpack_public_path__ + "static/media/slash-suspendedev.0f723fc92b4d32078ab05e7c70b39c33.svg";
export { ForwardRef as ReactComponent };